import { connect } from 'react-redux';
import { IState } from '../../../store';

import { IOfferMapGeoProps, OfferMapGeo } from './index';

function mapStateToProps(state: IState): IOfferMapGeoProps {
  return {
    address: state.offerData.offer.geo.address,
    highways: state.offerData.offer.geo.highways,
    undergrounds: state.offerData.offer.geo.undergrounds,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferMapGeoContainer = connect<IOfferMapGeoProps, any, any>(mapStateToProps)(OfferMapGeo);
